// extracted by mini-css-extract-plugin
export default {"contact":"contact___IYuKA","inline":"inline___wg5WC","name":"name___PWKwm","compact":"compact___VUBv_","compactAvatar":"compactAvatar___PzZr3","detail":"detail___fnsqL"};